import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, SectionLabel } from "@/components/ui/Card";
import type { CurrentPlanHealthPolicy } from "@/types";

const NOTE_KEYS: Record<string, string> = {
  training_days_required: "complete_profile",
  active_sports_required: "complete_profile",
  weekly_hours_required: "complete_profile",
  unsupported_sports: "unsupported_sports",
  session_limits_defaulted: "default_session_limits",
  long_day_moved_to_available_day: "long_day_moved",
  not_all_sports_fit_preview: "sports_do_not_fit",
  session_does_not_fit_budget: "session_does_not_fit",
};

export function PlanningQualityNotice({ provisional, notes = [], healthPolicy }: {
  provisional?: boolean;
  notes?: string[];
  healthPolicy?: CurrentPlanHealthPolicy;
}) {
  const { t } = useTranslation();
  const noteKeys = [...new Set(notes.map((note) => NOTE_KEYS[note]).filter(Boolean))];
  if (!provisional && !healthPolicy?.block_automatic_training) return null;
  return (
    <div className="space-y-3" role="status">
      {healthPolicy?.block_automatic_training ? (
        <Card className="border-coral/40">
          <SectionLabel>{t("planning_quality.health_title")}</SectionLabel>
          <p className="mt-2 text-sm text-navy">{t("planning_quality.health_body")}</p>
          <Link className="mt-2 inline-block text-sm underline" to="/settings">{t("planning_quality.settings")}</Link>
        </Card>
      ) : null}
      {provisional ? (
        <Card className="border-amber/50">
          <SectionLabel>{t("planning_quality.preview_title")}</SectionLabel>
          <p className="mt-2 text-sm text-navy">{t("planning_quality.preview_body")}</p>
          <p className="mt-2 text-sm text-taupe">{t("planning_quality.budget")}</p>
          {noteKeys.length ? (
            <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-navy">
              {noteKeys.map((key) => <li key={key}>{t(`planning_quality.${key}`)}</li>)}
            </ul>
          ) : null}
          <Link className="mt-2 inline-block text-sm underline" to="/settings">{t("planning_quality.settings")}</Link>
        </Card>
      ) : null}
    </div>
  );
}
